export class UserDetails {
    email: string;
    firstname: string;
    lastname: string;
    role:string;
    adminAccess:boolean;
    sub:string;
    iat: any;
    exp: any;
    userid:any

    refreshtoken: any;

    constructor(){}
}
